/* eslint-disable no-console */
export function logError(...args: unknown[]) { console.error(...args) }
export function logWarn(...args: unknown[]) { console.warn(...args) }
export function logInfo(...args: unknown[]) { console.log(...args) }
